var _style, _rect, _g, _mask, _rect2, _rect3, _rect4, _rect5, _rect6, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitAnalisis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 165,
    viewBox: "0 0 350 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n          .header {\n            font: 600 18px 'Segoe UI', Ubuntu, Sans-Serif;\n            fill: #fff;\n            animation: fadeInAnimation 0.8s ease-in-out forwards;\n          }\n          @supports(-moz-appearance: auto) {\n            /* Selector detects Firefox */\n            .header { font-size: 15.5px; }\n          }\n          .lang-name { font: 400 11px 'Segoe UI', Ubuntu, Sans-Serif; fill: #9f9f9f }\n\n          \n    /* Animations */\n    @keyframes scaleInAnimation {\n      from {\n        transform: translate(-5px, 5px) scale(0);\n      }\n      to {\n        transform: translate(-5px, 5px) scale(1);\n      }\n    }\n    @keyframes fadeInAnimation {\n      from {\n        opacity: 0;\n      }\n      to {\n        opacity: 1;\n      }\n    }\n  \n          * { animation-duration: 0s !important; animation-delay: 0s !important; }\n        ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-testid": "card-bg",
    x: 0.5,
    y: 0.5,
    rx: 4.5,
    height: "99%",
    stroke: "#e4e2e2",
    width: 349,
    fill: "#151515",
    strokeOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-testid": "card-title",
    transform: "translate(25, 35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    className: "header",
    "data-testid": "header"
  }, "Most Used Languages")))), /*#__PURE__*/React.createElement("g", {
    "data-testid": "main-card-body",
    transform: "translate(0, 55)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "lang-items",
    x: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "rect-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 300,
    height: 8,
    fill: "white",
    rx: 5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    mask: "url(#rect-mask)",
    "data-testid": "lang-progress",
    x: 0,
    y: 0,
    width: 84.96,
    height: 8,
    fill: "#e34c26"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    mask: "url(#rect-mask)",
    "data-testid": "lang-progress",
    x: 84.96,
    y: 0,
    width: 79.55,
    height: 8,
    fill: "#701516"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    mask: "url(#rect-mask)",
    "data-testid": "lang-progress",
    x: 164.51,
    y: 0,
    width: 67.73,
    height: 8,
    fill: "#f1e05a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    mask: "url(#rect-mask)",
    "data-testid": "lang-progress",
    x: 232.24,
    y: 0,
    width: 60.84,
    height: 8,
    fill: "#563d7c"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    mask: "url(#rect-mask)",
    "data-testid": "lang-progress",
    x: 293.08000000000004,
    y: 0,
    width: 16.91,
    height: 8,
    fill: "#C1F12E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 5,
    fill: "#e34c26"
  }), /*#__PURE__*/React.createElement("text", {
    "data-testid": "lang-name",
    x: 15,
    y: 10,
    className: "lang-name"
  }, "\n        HTML 28.32%\n      "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 25)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 5,
    fill: "#701516"
  }), /*#__PURE__*/React.createElement("text", {
    "data-testid": "lang-name",
    x: 15,
    y: 10,
    className: "lang-name"
  }, "\n        Ruby 26.52%\n      "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 5,
    fill: "#f1e05a"
  }), /*#__PURE__*/React.createElement("text", {
    "data-testid": "lang-name",
    x: 15,
    y: 10,
    className: "lang-name"
  }, "\n        JavaScript 22.58%\n      ")))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 5,
    fill: "#563d7c"
  }), /*#__PURE__*/React.createElement("text", {
    "data-testid": "lang-name",
    x: 15,
    y: 10,
    className: "lang-name"
  }, "\n        CSS 20.28%\n      "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 25)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 5,
    fill: "#C1F12E"
  }), /*#__PURE__*/React.createElement("text", {
    "data-testid": "lang-name",
    x: 15,
    y: 10,
    className: "lang-name"
  }, "\n        Batchfile 2.30%\n      ")))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitAnalisis);
export default __webpack_public_path__ + "static/media/gitAnalisis.939e94b513ad65634c5527c51e59dab7.svg";
export { ForwardRef as ReactComponent };